export enum ProfessionEnum
    {
        Medico = 1,
        Enfermeiro = 2,
        TecnicoDeEnfermagem = 3,
        Administrador = 8,
    }